import { createClient } from '@connectrpc/connect';
import { connectTransport } from '@mono/ui-runtime/connect';
import { RegistryRecordService } from '../../../../../../gen/ts/mono/datagateway/v1/registry_records_connect';
/** Browser client for pangaea's RegistryRecordService (REG-01; sabaody-routed). */ export const registryRecordClient = createClient(RegistryRecordService, connectTransport);
